import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

export default function MenuWithId({ menuItems, selectedItem, selectItem, size, placeholder, enabled }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    if (enabled) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (item) => {
    handleClose();
    selectItem(item);
  };

  let padding = 0;
  let component = 'h3';
  let variant = 'overline';

  if (size === 'normal') {
    padding = 8;
    component = 'div';
    variant = undefined;
  }

  return (
    <div>
      <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} style={{ padding }}>
        <Typography component={component} style={{ textAlign: 'left' }} variant={variant}>
          <div>{selectedItem ? selectedItem : placeholder}</div>
        </Typography>
        <ArrowDropDownIcon fontSize="small" />
      </Button>
      <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        <div>
          {menuItems.map((c) => (
            <MenuItem key={c.id} onClick={() => handleSelect(c)}>
              {c.name}
            </MenuItem>
          ))}
        </div>
      </Menu>
    </div>
  );
}

MenuWithId.propTypes = {
  menuItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedItem: PropTypes.string,
  selectItem: PropTypes.func.isRequired,
  size: PropTypes.string,
  placeholder: PropTypes.string,
  enabled: PropTypes.bool,
};

MenuWithId.defaultProps = {
  size: 'small',
  selectedItem: '',
  enabled: true,
};
